/**
 * @fileoverview Row of pre-send file chips for the chat input area.
 *
 * Hidden behind the `fileUpload` feature flag. Purely presentational: renders
 * one {@link FileChip} per attached file and forwards removal to the parent.
 * Renders nothing when there are no files.
 */

import React from "react";
import { UploadFile } from "./types";
import { FileChip } from "./FileChip";

interface FileChipListProps {
  /** The attached files to render as chips. */
  files: UploadFile[];
  /** Called with the file id when a chip's ✕ remove button is clicked. */
  onRemove: (id: string) => void;
}

/**
 * Renders the wrapping row of file chips, or `null` when the list is empty.
 */
export const FileChipList = ({ files, onRemove }: FileChipListProps) => {
  if (files.length === 0) {
    return null;
  }

  return (
    <div
      data-testid="file-chip-list"
      className="flex flex-wrap gap-2 px-3 pt-3"
    >
      {files.map((file) => (
        <FileChip key={file.id} file={file} onRemove={onRemove} />
      ))}
    </div>
  );
};

export default FileChipList;
